import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { DialogFooter, DialogClose } from "@/components/ui/dialog";

const UserForm = ({ user, onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    name: '',
    email: '',
    role: 'admin',
    status: 'active'
  });

  useEffect(() => {
    if (user) {
      setFormData({
        username: user.username || '',
        password: '',
        name: user.name || '',
        email: user.email || '',
        role: user.role || 'admin',
        status: user.status || 'active'
      });
    } else {
      setFormData({
        username: '',
        password: '',
        name: '',
        email: '',
        role: 'admin',
        status: 'active'
      });
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSelectChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <Label htmlFor="username">ชื่อผู้ใช้ (Username)</Label>
        <Input id="username" name="username" value={formData.username} onChange={handleChange} required placeholder="เช่น admin2" />
      </div>
      <div>
        <Label htmlFor="name">ชื่อ-นามสกุล</Label>
        <Input id="name" name="name" value={formData.name} onChange={handleChange} placeholder="(ไม่บังคับ)" />
      </div>
      <div>
        <Label htmlFor="email">อีเมล</Label>
        <Input id="email" name="email" type="email" value={formData.email} onChange={handleChange} placeholder="(ไม่บังคับ)" />
      </div>
      <div>
        <Label htmlFor="role">ตำแหน่ง</Label>
        <Select name="role" value={formData.role} onValueChange={(value) => handleSelectChange('role', value)}>
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="admin">ผู้ดูแลระบบ</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div>
        <Label htmlFor="status">สถานะ</Label>
        <Select name="status" value={formData.status} onValueChange={(value) => handleSelectChange('status', value)}>
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="active">Active</SelectItem>
            <SelectItem value="inactive">Inactive</SelectItem>
          </SelectContent>
        </Select>
      </div>
      {!user ? (
        <div>
          <Label htmlFor="password">รหัสผ่าน</Label>
          <Input id="password" name="password" type="password" value={formData.password} onChange={handleChange} required minLength={6} />
          <p className="text-xs text-gray-500 mt-1">รหัสผ่านอย่างน้อย 6 ตัวอักษร</p>
        </div>
      ) : (
        <div>
          <Label htmlFor="password">รหัสผ่านใหม่ (ถ้าต้องการเปลี่ยน)</Label>
          <Input id="password" name="password" type="password" value={formData.password} onChange={handleChange} placeholder="เว้นว่างถ้าไม่เปลี่ยน" />
        </div>
      )}
      <DialogFooter>
        <DialogClose asChild>
          <Button type="button" variant="outline" onClick={onCancel}>ยกเลิก</Button>
        </DialogClose>
        <Button type="submit" className="bg-violet-600 hover:bg-violet-700 text-white">
          {user ? 'บันทึกการเปลี่ยนแปลง' : 'เพิ่มผู้ใช้งาน'}
        </Button>
      </DialogFooter>
    </form>
  );
};

export default UserForm;
